import React from "react";
import Seo from "@/components/vlyt/Seo";

const SECTIONS = [
  { h: "1. Acceptance", p: "By using Vlyt, you agree to these terms. If you don't agree, do not use the service." },
  { h: "2. Eligibility", p: "Vlyt is currently limited to verified Covenant University students, verified drivers, and invited staff." },
  { h: "3. Royal Rides pass", p: "The Royal Rides pass secures a recurring 8:00 AM pickup (or your selected time) at your residence hall. Pricing is customized to your unique weekly routine. Cancel anytime with no exit fee." },
  { h: "4. Payment", p: "All payments settle to the driver directly, minus the flat ₦10 Vlyt Platform Access Fee. Vlyt does not skim per-trip fees beyond this transparent access charge." },
  { h: "5. Driver terms", p: "Drivers must maintain a valid license, verified vehicle papers, and a minimum 4.7 star rating for Royal-tier matches. Drivers retain 95 percent of every standard fare." },
  { h: "6. Prohibited conduct", p: "Harassment, weapons, illegal cargo, or misuse of matric-number-linked accounts results in permanent removal." },
  { h: "7. Liability", p: "Vlyt Technologies Ltd is not liable for indirect or consequential damages. Total liability is capped at the amount paid to Vlyt in the past 30 days." },
  { h: "8. Changes", p: "We may update these terms. Material changes are announced by email 14 days before taking effect." },
];

export default function Terms() {
  return (
    <>
      <Seo title="Terms of Service · Vlyt" canonical="https://govlyt.com/terms" />
      <section className="pt-[120px] pb-24 mx-auto max-w-[880px] px-5 md:px-10">
        <div className="text-eyebrow mb-4">Legal</div>
        <h1 className="text-h1 font-display">Terms of Service</h1>
        <p className="mt-3 text-[color:var(--vlyt-muted)] font-mono text-[13px]">Effective at platform launch</p>

        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <div key={s.h}>
              <h2 className="text-h3 font-display text-[color:var(--vlyt-text)]">{s.h}</h2>
              <p className="mt-3 text-[color:var(--vlyt-muted)] text-[15px] leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
